<template>
  <div id="editor-container">
    <ckeditor
      :editor="editor"
      v-model="postContent"
      :config="editorConfig"
    ></ckeditor>
  </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  name: "Editor",
  props: {
    content: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        toolbar: {
          items: [
            "bold",
            "italic",
            "link",
            "undo",
            "redo",
            "heading",
            "paragraph"
          ]
        },
        width: "100%"
      },
      contentData: ""
    };
  },
  mounted() {
    this.contentData = this.content;
  },
  computed: {
    postContent: {
      get() {
        return this.content;
      },
      set(value) {
        this.$emit("updateContent", value);
        this.contentData = value;
      }
    }
  }
};
</script>

<style lang="scss">
#editor-container {
  display: inline-block !important;
  margin-right: 0.75rem;

  @media all and (max-width: 1367px) {
    max-width: 636px !important;
    margin-right: 0.75rem;
  }
}
</style>
